import { provideState } from '@ngrx/store';

import { bannersFeature } from './banners.reducer';

export const bannersStore = [provideState(bannersFeature)];
